import { render, staticRenderFns } from "./coffee-index-home.vue?vue&type=template&id=11d9fcaa&scoped=true&"
import script from "./coffee-index-home.vue?vue&type=script&lang=js&"
export * from "./coffee-index-home.vue?vue&type=script&lang=js&"
import style0 from "./coffee-index-home.vue?vue&type=style&index=0&id=11d9fcaa&prod&lang=scss&scoped=true&"
import style1 from "./coffee-index-home.vue?vue&type=style&index=1&id=11d9fcaa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d9fcaa",
  null
  
)

export default component.exports